import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { onAuthStateChanged, signOut } from "firebase/auth";
import { auth } from "../../lib/firebase";
import { getAdminEmails } from "../../lib/admins";

// TEMPORARY (2026-08-18, Juan's request): let ANY signed-in GitHub user in
// while he's iterating quickly. Firestore's `isAdmin()` check is also
// relaxed to match (see firestore.rules) — flip this back to `false` once
// he's done, since this Firebase project has other, unrelated GitHub users
// from a different app who would otherwise be able to write articles too.
const OPEN_TO_ALL_SIGNED_IN = true;

const RequireAuth = ({ children }) => {
  const [user, setUser] = useState(undefined); // undefined = checking
  const [adminEmails, setAdminEmails] = useState(undefined);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, setUser);
    return unsubscribe;
  }, []);

  useEffect(() => {
    if (!user) return;
    getAdminEmails()
      .then(setAdminEmails)
      .catch(() => setAdminEmails([]));
  }, [user]);

  if (user === undefined) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-space text-gray-400">
        Checking session…
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/admin/login" replace />;
  }

  if (adminEmails === undefined) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-space text-gray-400">
        Checking permissions…
      </div>
    );
  }

  if (!OPEN_TO_ALL_SIGNED_IN && !adminEmails.includes(user.email)) {
    return (
      <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-space px-6 text-center text-white">
        <h1 className="text-2xl font-bold">Not authorized</h1>
        <p className="text-gray-400">
          This GitHub account isn't on the Nodefleet admin list.
        </p>
        <button
          type="button"
          onClick={() => signOut(auth)}
          className="rounded-full border border-white/20 px-6 py-2.5 text-sm font-semibold text-white transition-colors hover:border-white/40"
        >
          Sign out
        </button>
      </div>
    );
  }

  return children;
};

export default RequireAuth;
